module.exports = __webpack_public_path__ + "img/1544619644.623b4149.jpg";